import http from '../_http'

const PressImages = {
  getAlbums: params => http.get('/msvc/v1/pressimages/albums/available', params),
  getImages: params => http.get('/msvc/v1/pressimages/search', params)
}

export default PressImages
